(function(ochsner, $, undefined) {

    //Private Property
    var url = location.href;

    //
    // public method: get query variable in URL
    // usage: ochsner.getQueryVariable();
    //
    ochsner.getQueryVariable = function(url) {
        name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
        var regexS = "[\\?&]"+name+"=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(url);
        return results == null ? null : results[1];
    };

    //
    // public method: set height an obj
    // usage: ochsner.setObjectHeight('.page-section');
    //
    ochsner.setObjectHeight = function(obj) {
        //var navHeight = $('.navbar').height();
        //var objHeight = $(window).height() - navHeight;
        var winHeight = $(window).height();
        $(this).css('height', winHeight);
        return;
    };

    //
    // public method: set a persona cookie
    // usage: ochsner.setPersonaCookie(name, value, days);
    //
    ochsner.setPersonaCookie = function(name, value, days) {
        $.cookie(name, value, {
            expires: days, // Expires in 360 days
            path: '/', // Is on the default path
            domain: 'ochsner.' + getTld(), // The value of the domain attribute of the cookie
            secure: getProtocol() // set secure cookies - setting in htaccess
        });
        $('.persona-current').text($.cookie('och_persona_longname')); // update the persona longname in modal
        return;
    };

    //
    // private method: get the current protocol (http: https:)
    // usage: getProtocol()
    //
    function getProtocol() {
        var proto = document.location.protocol;
        var protoSecure;
        if (proto === 'http:') {
            protoSecure = false;
            return protoSecure;
        } else {
            protoSecure = true;
            return protoSecure;
        }
    }

    //
    // private method: get the current tld (eg. .org, .com, .local)
    // usage: getTld()
    //
    function getTld() {
        var tld = document.location.hostname.split('.').pop();
        return tld;
    }

}(window.ochsner = window.ochsner || {}, jQuery));

(function(ochGlobal, $, undefined) {

    ochGlobal.setObjectHeight = function(obj) {
        //var navHeight = $('.navbar').height();
        //var objHeight = $(window).height() - navHeight;
        var winHeight = $(window).height();
        $(this).css('height', winHeight);
        return;
    };

}(window.ochGlobal = window.ochGlobal || {}, jQuery));